<template>
  <div class="p-grid">
    <div class="p-col">
      <Toast position="bottom-left" />

      <Toolbar class="p-mb-4">
        <template slot="right">
          <Button
            label="ردیف جدید"
            @click="goCreatePage"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
          />
        </template>
        <template slot="left">
          <Button
            label="حذف"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="confirmDeleteSelected"
            :disabled="!selectedItems || !selectedItems.length"
          />
        </template>
      </Toolbar>

      <DataTable
        :value="listItems"
        :filters="filters"
        :loading="loading"
        selectionMode="multiple"
        :selection.sync="selectedItems"
        data-key="id"
        :paginator="true"
        :lazy="true"
        :totalRecords="totalRecords"
        @page="onPage"
        @sort="onSort"
        :rows="rows"
        @row-click="onRowClick"
        :first="firstRecordIndex"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
        currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
      >
        <template #empty>آیتمی یافت نشد</template>

        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column
          v-for="col of columns"
          :field="col.field"
          :header="col.header"
          :key="col.field"
          :sortable="col.sortable"
        >
          <template #filter v-if="col.filterable">
            <InputText
              type="text"
              v-model="filters[col.field]"
              @keypress.enter="filterBy"
              class="p-column-filter"
            />
          </template>
        </Column>
        <Column header="مدیریت" v-if="columns">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-ml-2"
              @click="goEditPage(slotProps.data)"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning"
              @click="confirmDeleteItem(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>

      <Dialog
        :visible.sync="deleteItemsDialog"
        :style="{ width: '450px' }"
        header="تایید حذف"
        :modal="true"
      >
        <div class="confirmation-content">
          <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem"
          />
          <span>آیا از حذف موارد انتخاب شده مطمئن هستید؟</span>
        </div>
        <template #footer>
          <Button
            label="خیر"
            icon="pi pi-times"
            class="p-button-text"
            @click="deleteItemsDialog = false"
          />
          <Button
            label="بله"
            icon="pi pi-check"
            class="p-button-text"
            @click="deleteSelectedItems"
          />
        </template>
      </Dialog>

      <Dialog
        :visible.sync="deleteItemDialog"
        :style="{ width: '450px' }"
        header="تایید حذف"
        :modal="true"
      >
        <div class="confirmation-content">
          <i
            class="pi pi-exclamation-triangle p-mr-3"
            style="font-size: 2rem"
          />
          <span v-if="item">آیا از حذف مورد انتخاب شده مطمئن هستید؟</span>
        </div>
        <template #footer>
          <Button
            label="خیر"
            icon="pi pi-times"
            class="p-button-text"
            @click="deleteItemDialog = false"
          />
          <Button
            label="بله"
            icon="pi pi-check"
            class="p-button-text"
            @click="deleteItem"
          />
        </template>
      </Dialog>
    </div>
  </div>
</template>


<script>
import CrudService from "@/service/CrudService";
import helper from "../helper";

export default {
  props: {
    moduleName: {
      type: String,
      default: "",
    },
    moduleLabel: {
      type: String,
      default: "",
    },
    rowsInPage: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      filters: {},
      columns: null,
      loading: true,
      totalRecords: 0,
      pageNumber: 0,
      sortField: null,
      sortOrder: null,
      rows: this.rowsInPage,
      listItems: null,
      selectedItems: null,
      item: null,
      deleteItemsDialog: false,
      deleteItemDialog: false,
    };
  },
  service: null,
  computed: {
    firstRecordIndex: function () {
      return this.pageNumber * this.rowsInPage;
    },
    filtersString: function () {
      let filters = [];
      let filtersObj = JSON.parse(JSON.stringify(this.filters));
      for (const key in filtersObj) {
        if (filtersObj.hasOwnProperty(key)) {
          filters.push(`${key}=${filtersObj[key]}`);
        }
      }
      return filters.join(";");
    },
  },
  watch: {
    async $route(to) {
      this.service = new CrudService(to.params.module, this);
      this.columns = null;
      this.listItems = null;
      await this.fetchItems();
    },
  },
  methods: {
    onRowClick() {
      const selectedItems = this.selectedItems;
      setTimeout(() => {
        this.selectedItems = selectedItems;
      }, 10);
    },
    confirmDeleteSelected() {
      this.deleteItemsDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    async deleteSelectedItems() {
      const selected_ids = this.selectedItems.map((item) => item.id);

      const success = await this.service.deleteItems(selected_ids);
      this.deleteItemsDialog = false;

      helper.toastDeleteResult(success,this.$toast);

      this.pageNumber = 0;
      await this.fetchItems();

      this.selectedItems = null;
    },
    async deleteItem() {
      const success = await this.service.deleteItem(this.item.id);
      this.deleteItemDialog = false;

      helper.toastDeleteResult(success,this.$toast);

      if (success) {
        //delete row cliet side
        this.listItems = this.listItems.filter(
          (item) => item.id !== this.item.id
        );
      }

      this.item = null;
    },
    goEditPage(data) {
      this.$router.push({ path: `/Edit/${this.moduleName}/${data.id}` });
    },
    goCreatePage() {
      this.$router.push({ path: `/Create/${this.moduleName}` });
    },
    async filterBy() {
      this.pageNumber = 0;
      await this.fetchItems();
    },
    async onSort(event) {
      this.pageNumber = 0;
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder;
      await this.fetchItems();
    },
    async onPage(event) {
      this.pageNumber = event.page;
      await this.fetchItems();
    },
    async fetchItems() {
      this.loading = true;
      try {
        const list = await this.service.getList(
          this.rows,
          this.pageNumber,
          this.filtersString,
          this.sortField,
          this.sortOrder
        );
        if (!this.columns) this.columns = list.columns;
        this.totalRecords = list.totalCount;
        this.listItems = list.items;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: `اشکال در بارگذاری اطلاعات!`,
          detail: error,
        });
      }
      this.loading = false;
    },
  },
  created() {
    this.service = new CrudService(this.moduleName, this);
  },
  async mounted() {
    await this.fetchItems();
  },
};
</script>

<style scoped>
</style>